<template>
    <div>
        <b-card no-body v-show="mostrarPropostasPrecos">
            <b-card-header>
                <div class="float-left">
                    <span class="h5">Propostas de Preços</span>

                    <span class="ml-2 text-primary">
                        <i class="fa fa-refresh fa-lg icon-button" title="Atualizar"
                            @click.stop="obterPropostasPrecos()"></i>
                    </span>
                </div>
            </b-card-header>
            <b-card-body>

                <b-row>
                    <b-col>
                        <b-form-group>
                            <label class="font-weight-bold">Num. Licitação</label>
                            <b-input
                                v-model="filtro.numeroLicitacao"
                                v-mask="'###/####-AAA'"
                                placeholder="000/0000-XXX"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group>
                            <label class="font-weight-bold">De</label>
                            <date-picker
                                v-model="filtro.dataDe"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group>
                            <label class="font-weight-bold">Até</label>
                            <date-picker
                                v-model="filtro.dataAte"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group class="filtro-status">
                            <label class="font-weight-bold">Status</label>
                            <model-list-select
                                class="form-control"
                                :list="listaStatus"
                                v-model="filtro.status"
                                option-text="descricao"
                                option-value="codStatus"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mb-3 align-items-center">
                    <b-col class="d-flex flex-wrap">
                        <b-button
                            class="mr-2 mb-1"
                            variant="primary"
                            @click.stop="obterPropostasPrecos()"
                        >
                            <i class="fa fa-search mr-1"></i>
                            Pesquisar
                        </b-button>
                        <b-button
                            class="mb-1"
                            variant="secondary"
                            @click.stop="limparFiltro()"
                        >
                            Limpar Filtro
                        </b-button>
                    </b-col>
                    <b-col class="d-flex justify-content-end flex-wrap">
                        <b-button
                            v-if="mostrarBotaoNovaPropostaPreco"
                            class="mb-1"
                            variant="primary"
                            @click.stop="novaPropostaPreco()"
                        >
                            <i class="fa fa-plus mr-1"></i> Nova Solicitação
                        </b-button>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="propostas-precos-tabela">
                        <app-tabela
                            :itens="propostasPrecos"
                            :campos="camposTabela"
                            :bordered="false"
                            :small="false"
                            :textoTabelaVazia="textoTabelaVazia"
                        >
                            <template slot="dataBaseReajustamento" slot-scope="data">
                                {{ data.dataBaseReajustamento | toDate }}
                            </template>

                            <template slot="acoes" slot-scope="data">
                                <span class="text-primary mr-2">
                                    <i
                                        class="fa fa-lg fa-info-circle icon-button"
                                        title="Detalhar"
                                        @click.stop="detalhar(data.propostaPrecoId)"
                                    ></i>
                                </span>
                                <span
                                    v-if="propostaPrecoEditavel(data)"
                                    class="text-primary mr-2">
                                    <i
                                        class="fa fa-lg fa-edit icon-button"
                                        title="Editar"
                                        @click.stop="editar(data.propostaPrecoId)"
                                    ></i>
                                </span>
                                <span
                                    v-if="propostaPrecoExcluivel(data)"
                                    class="text-danger mr-2"
                                >
                                    <i
                                        class="fa fa-lg fa-trash icon-button"
                                        title="Excluir"
                                        @click.stop="confirmarExclusao(data)"
                                    ></i>
                                </span>
                            </template>
                        </app-tabela>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>

        <router-view
            @obterPropostasPrecos="obterPropostasPrecos"
        />
    </div>
</template>

<script>
import PropostaPrecoServico from './PropostaPrecoServico'
import { ModelListSelect } from 'vue-search-select'
import moment from 'moment'

export default {
    components: {
        ModelListSelect
    },

    data() {
        return {
            listaStatus: [
                { descricao: 'Todas', codStatus: '' },
                { descricao: 'Aguardando Proponente', codStatus: 1 },
                { descricao: 'Aguardando envio da Proposta', codStatus: 2 },
                { descricao: 'Proposta Preenchida', codStatus: 3 },
                { descricao: 'Proposta Finalizada', codStatus: 4 },
                { descricao: 'Solicitado Diligência', codStatus: 5 },
                { descricao: 'Fornecedor Habilitado', codStatus: 6 },
            ],
            filtro: {
                numeroLicitacao: '',
                dataDe: null,
                dataAte: null,
                status: ''
            },
            propostasPrecos: [],
            camposTabela: [
                {
                    key: 'numeroLicitacao',
                    label: 'Num. Licitação',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'objetoContratacao',
                    label: 'Objeto',
                    filterable: true,
                    sortable: true,
                    tdClass: 'objeto-coluna'
                },
                {
                    key: 'statusDescricao',
                    label: 'Status',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'dataBaseReajustamento',
                    label: 'Data Base Reajustamento',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'acoes',
                    label: 'Ações',
                    thClass: 'acoes-coluna',
                    tdClass: 'acoes-coluna text-center text-nowrap'
                },
            ],
        }
    },

    computed: {
        mostrarPropostasPrecos() {
            return this.$route.name === 'PropostasPrecos'
        },

        mostrarBotaoNovaPropostaPreco(){
            return this.$temAcessoView('PROP-PRECO-ADD-00')
        },

        textoTabelaVazia() {
            return this.$store.getters.isFornecedor ?
                'Nenhuma solicitação vinculada ao seu CNPJ' : 'Não existem dados a serem exibidos'
        },
    },

    methods: {
        converterFiltroData(data, fimDoDia = false) {
            if (!data) {
                return null
            }

            const dataMoment = moment(data, 'DD/MM/YYYY', true).isValid()
                ? moment(data, 'DD/MM/YYYY')
                : moment(data)

            if (!dataMoment.isValid()) {
                return null
            }

            return fimDoDia ? dataMoment.endOf('day') : dataMoment.startOf('day')
        },

        aplicarFiltroDataVinculoFornecedor(propostasPrecos) {
            const dataDe = this.converterFiltroData(this.filtro.dataDe)
            const dataAte = this.converterFiltroData(this.filtro.dataAte, true)

            if (!dataDe && !dataAte) {
                return propostasPrecos
            }

            return propostasPrecos.filter(propostaPreco => {
                if (!propostaPreco.dataVinculoFornecedor) {
                    return false
                }

                const dataVinculoFornecedor = moment(propostaPreco.dataVinculoFornecedor)

                if (!dataVinculoFornecedor.isValid()) {
                    return false
                }

                if (dataDe && dataVinculoFornecedor.isBefore(dataDe)) {
                    return false
                }

                if (dataAte && dataVinculoFornecedor.isAfter(dataAte)) {
                    return false
                }

                return true
            })
        },

        obterPropostasPrecos() {
			this.$store.dispatch('addRequest')

            PropostaPrecoServico.Obter(this.filtro)
                .then(response => {
                    this.propostasPrecos = this.aplicarFiltroDataVinculoFornecedor(response.data || [])
                })
                .catch(error => {
                    console.error('Erro ao obter propostas de preços:', error)
                })
                .finally(() => {
			        this.$store.dispatch('removeRequest')
                })
        },

        novaPropostaPreco() {
            this.$router.push({ name: 'PropostasPrecos_Nova' })
        },

        detalhar(propostaPrecoId) {
            this.$router.push({
                name: 'PropostasPrecos_Detalhe',
                params: { propostaPrecoId }
            })
        },

        editar(propostaPrecoId) {
            this.$router.push({
                name: 'PropostasPrecos_Editar',
                params: { propostaPrecoId }
            })
        },

        propostaPrecoEditavel(propostaPreco) {
            let AGUARDANDO_PROPONENTE = 1;

            return propostaPreco.status == AGUARDANDO_PROPONENTE && this.$temAcessoView('PROP-PRECO-ATU-00')
        },

        propostaPrecoExcluivel(propostaPreco) {
            const AGUARDANDO_PROPONENTE = 1;

            return propostaPreco.status == AGUARDANDO_PROPONENTE
                && !propostaPreco.fornecedorId
                && this.$temAcessoView('PROP-PRECO-ATU-00')
        },

        confirmarExclusao(propostaPreco) {
            this.$swal({
                title: 'Exclusão de Proposta de Preço',
                html: `Confirma a exclusão da proposta <b>${propostaPreco.numeroLicitacao}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Nao'
            }).then(result => {
                if (result.value) {
                    this.excluirPropostaPreco(propostaPreco.propostaPrecoId)
                }
            })
        },

        excluirPropostaPreco(propostaPrecoId) {
            this.$store.dispatch('addRequest')

            PropostaPrecoServico.Excluir(propostaPrecoId)
                .then(response => {
                    if (response && response.success) {
                        this.$toast.success(
                            'Proposta de preço excluída com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterPropostasPrecos()
                    } else {
                        this.$toast.error(
                            'Erro ao excluir proposta de preço.',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                })
                .catch(error => {
                    console.error('Erro ao excluir proposta de preço:', error)
                    this.$toast.error(
                        'Erro ao excluir proposta de preço.',
                        'ERROR',
                        this.$toastConfig.error
                    )
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },

        limparFiltro() {
            this.filtro = {
                numeroLicitacao: '',
                dataDe: null,
                dataAte: null,
                status: ''
            }

            this.obterPropostasPrecos();
        },
    },

    mounted() {
        this.obterPropostasPrecos();
    },

    watch: {
        '$route'(to, from) {
            if (to.name === 'PropostasPrecos') {
                this.obterPropostasPrecos();
            }
        }
    }
}

</script>

<style>
.filtro-status .ui.search.dropdown {
    display: flex;
    align-items: center;
    font-family: inherit;
    font-size: inherit;
}

.filtro-status .ui.search.dropdown > input.search {
    flex: 1 1 auto;
    min-width: 0;
    font-family: inherit;
    font-size: inherit;
}

.filtro-status .ui.search.dropdown > .text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    line-height: 1.5;
    font-family: inherit;
    font-size: inherit;
}

.filtro-status .ui.search.dropdown .menu .item {
    font-family: inherit;
    font-size: inherit;
}

.propostas-precos-tabela .objeto-coluna {
    white-space: normal !important;
    word-break: break-word;
    min-width: 280px;
}

.propostas-precos-tabela .acoes-coluna {
    width: 110px;
    min-width: 110px;
}

@media (max-width: 1366px) {
    .propostas-precos-tabela table {
        font-size: 0.92rem;
    }

    .propostas-precos-tabela .objeto-coluna {
        min-width: 220px;
    }

    .propostas-precos-tabela .acoes-coluna {
        width: 90px;
        min-width: 90px;
    }
}
</style>
